/**
 * @generated SignedSource<<17135449601ae3ba82caadd700c945fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Recurring",
    "kind": "LinkedField",
    "name": "createRecurring",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "claim",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "confirmRecurringMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "confirmRecurringMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f8f298075788738405f52728e82ce6a1",
    "id": null,
    "metadata": {},
    "name": "confirmRecurringMutation",
    "operationKind": "mutation",
    "text": "mutation confirmRecurringMutation(\n  $request: RecurringRequestInput!\n) {\n  createRecurring(request: $request) {\n    id\n    claim\n  }\n}\n"
  }
};
})();

node.hash = "19ecf239835017f5b914f92a90deda39";

module.exports = node;
